/* Hot Farm · collection page: filters, sort, chips and paging without page reloads.
   Only the section is fetched (Section Rendering API, ?section_id=…), the parts marked with
   [data-hf-coll-part] are swapped, the URL follows with pushState, so Back and shared links work.
   Without JavaScript the same form, links and pagination work as plain requests. */
(function () {
  'use strict';
  if (window.HFCollection) return;
  window.HFCollection = true;

  var PARTS = ['head', 'cats', 'chips', 'filters', 'results'];
  var ROWS = '.hf-coll-chips__list, .hf-coll-cats__list';
  var cache = new Map();
  var seq = 0;
  var ctrl = null;
  var timer = null;
  var shownUrl = location.pathname + location.search;
  var mqPanel = window.matchMedia('(max-width: 1023px)');

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function part(scope, name) { return scope && scope.querySelector('[data-hf-coll-part="' + name + '"]'); }
  function root() { var r = $('[data-hf-coll-part="results"]'); return r && r.closest('.shopify-section'); }
  function sectionId(sec) { return sec.id.replace(/^shopify-section-/, ''); }

  /* path + query without section_id and without empty params */
  function cleanUrl(url) {
    var u = new URL(url, location.href);
    var p = new URLSearchParams();
    u.searchParams.forEach(function (v, k) { if (v !== '' && k !== 'section_id') p.append(k, v); });
    var q = p.toString();
    return u.pathname + (q ? '?' + q : '');
  }
  function formUrl(form) {
    return cleanUrl(form.getAttribute('action') + '?' + new URLSearchParams(new FormData(form)).toString());
  }

  function load(url, sec) {
    if (ctrl) { ctrl.abort(); ctrl = null; }
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    ctrl = new AbortController();
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId(sec)), { signal: ctrl.signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        cache.set(url, html);
        if (cache.size > 30) cache.delete(cache.keys().next().value);
        return html;
      });
  }
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.shopify-section') || doc.body;
  }

  function setBusy(sec, on) {
    var res = part(sec, 'results');
    if (!res) return;
    res.classList.toggle('is-loading', on);
    if (on) res.setAttribute('aria-busy', 'true'); else res.removeAttribute('aria-busy');
  }

  /* Offset of the sticky filter bar: under the fixed header row when it is shown (phone/tablet) */
  var header = $('[data-hf-header]');
  function headerOffset() {
    if (!mqPanel.matches || !header) return 16;
    var row = header.querySelector('.hf-header__row');
    var shown = header.classList.contains('is-stuck') && !header.classList.contains('is-hidden');
    return shown && row ? row.offsetHeight + 16 : 8;
  }
  function syncTop() { document.documentElement.style.setProperty('--hf-coll-top', headerOffset() + 'px'); }
  if (header) new MutationObserver(syncTop).observe(header, { attributes: true, attributeFilter: ['class'] });
  mqPanel.addEventListener ? mqPanel.addEventListener('change', syncTop) : mqPanel.addListener(syncTop);
  syncTop();

  /* If the start of the results is above the screen, bring it just under the header; otherwise the page stays put */
  function revealResults() {
    var res = part(root(), 'results');
    if (!res || document.body.classList.contains('hf-filters-open')) return;
    var top = res.getBoundingClientRect().top;
    if (top >= 0) return;
    var row = header && header.querySelector('.hf-header__row');
    var off = mqPanel.matches ? (row ? row.offsetHeight + 16 : 8) : 16;
    window.scrollTo(0, Math.max(0, window.scrollY + top - off + (mqPanel.matches ? 8 : 0)));
  }

  /* The chosen chip or category stays visible in its sideways-scrolling row */
  function keepChipInView(sec) {
    $$(ROWS, sec).forEach(function (list) {
      var on = $('[aria-current]', list);
      if (!on) return;
      var l = list.getBoundingClientRect(), c = on.getBoundingClientRect();
      if (c.left < l.left || c.right > l.right) list.scrollLeft += c.left - l.left - 12;
    });
  }

  function render(html) {
    var sec = root();
    var fresh = parse(html);
    var aside = part(sec, 'filters');
    var act = document.activeElement;
    var focusSel = null;
    if (act && act.name && aside && aside.contains(act)) {
      focusSel = '[name="' + CSS.escape(act.name) + '"]' + (act.type === 'checkbox' ? '[value="' + CSS.escape(act.value) + '"]' : '');
    }
    var asideTop = aside ? aside.scrollTop : 0;
    var lists = aside ? $$('.hf-filters__list', aside).map(function (l) { return l.scrollTop; }) : [];
    var rowLeft = $$(ROWS, sec).map(function (l) { return l.scrollLeft; });
    var oldRes = part(sec, 'results');
    var oldTitle = oldRes ? oldRes.getAttribute('data-hf-page-title') : '';

    PARTS.forEach(function (name) {
      var cur = part(sec, name), nu = part(fresh, name);
      if (!cur || !nu) return;
      cur.innerHTML = nu.innerHTML;
      if (name === 'results') {
        ['data-hf-page-title', 'data-hf-live'].forEach(function (a) { cur.setAttribute(a, nu.getAttribute(a) || ''); });
      }
    });

    if (aside) {
      aside.scrollTop = asideTop;
      $$('.hf-filters__list', aside).forEach(function (l, i) { if (lists[i]) l.scrollTop = lists[i]; });
      if (focusSel) { var f = $(focusSel, aside); if (f) f.focus({ preventScroll: true }); }
      initRanges(aside);
    }
    var rows = $$(ROWS, sec);
    if (rows.length === rowLeft.length) rows.forEach(function (l, i) { l.scrollLeft = rowLeft[i]; });
    keepChipInView(sec);

    var res = part(sec, 'results');
    var tg = $('[data-hf-filters-toggle]', res);
    if (tg && aside) tg.setAttribute('aria-expanded', aside.classList.contains('is-open') ? 'true' : 'false');
    var newTitle = res.getAttribute('data-hf-page-title');
    if (oldTitle && newTitle && oldTitle !== newTitle) document.title = document.title.replace(oldTitle, newTitle);
    var live = $('[data-hf-coll-live]', sec);
    if (live) live.textContent = res.getAttribute('data-hf-live') || '';
    if (window.HF && HF.init) HF.init(res);
  }

  /* Load url into the page. opts.push: new history entry; opts.reveal: bring the results into view */
  function go(url, opts) {
    opts = opts || {};
    var sec = root();
    if (!sec) { location.href = url; return; }
    url = cleanUrl(url);
    var my = ++seq;
    setBusy(sec, true);
    load(url, sec).then(function (html) {
      if (my !== seq) return;
      render(html);
      if (opts.push && url !== shownUrl) history.pushState({ hfColl: 1 }, '', url);
      shownUrl = url;
      setBusy(root(), false);
      if (opts.reveal) revealResults();
    }).catch(function (err) {
      if (my !== seq || (err && err.name === 'AbortError')) return;
      location.href = url; // e.g. a collection with another template has no such section
    });
  }

  /* "Show more": the next page is appended under the current products */
  function more(a) {
    var sec = root(), res = part(sec, 'results');
    var grid = res && $('.hf-grid', res);
    if (!grid) { location.href = a.href; return; }
    var url = cleanUrl(a.href);
    var hadFocus = document.activeElement === a;
    var my = ++seq;
    a.classList.add('is-loading');
    a.setAttribute('aria-busy', 'true');
    load(url, sec).then(function (html) {
      if (my !== seq) return;
      var fres = part(parse(html), 'results');
      var fgrid = fres && $('.hf-grid', fres);
      if (!fgrid) { location.href = url; return; }
      var added = Array.prototype.slice.call(fgrid.children);
      added.forEach(function (c) { grid.appendChild(c); });
      var foot = $('[data-hf-coll-foot]', res), ffoot = $('[data-hf-coll-foot]', fres);
      if (foot) foot.innerHTML = ffoot ? ffoot.innerHTML : '';
      var shown = $('.hf-results__shown', res), fshown = $('.hf-results__shown', fres);
      if (shown && fshown) shown.textContent = fshown.textContent;
      if (window.HF && HF.init) HF.init(grid);
      if (hadFocus && added[0]) {
        var l = added[0].querySelector('a[href]:not([tabindex="-1"])') || added[0].querySelector('a[href]');
        if (l) l.focus({ preventScroll: true });
      }
    }).catch(function (err) {
      if (my !== seq || (err && err.name === 'AbortError')) return;
      location.href = url;
    });
  }

  /* ---------- price range: two sliders write into the named number fields ---------- */
  function initRanges(scope) {
    $$('[data-hf-range-wrap]', scope).forEach(function (wrap) {
      if (wrap.dataset.hfInit) return;
      wrap.dataset.hfInit = '1';
      var lo = $('[data-hf-range="min"]', wrap), hi = $('[data-hf-range="max"]', wrap);
      var fill = $('.hf-range__fill', wrap);
      var loOut = $('[data-hf-range-out="min"]', wrap), hiOut = $('[data-hf-range-out="max"]', wrap);
      var loIn = $('[data-hf-range-input="min"]', wrap), hiIn = $('[data-hf-range-input="max"]', wrap);
      if (!lo || !hi) return;
      var max = parseFloat(lo.max);
      var money = function (v) { return window.HF && HF.formatMoney ? HF.formatMoney(Math.round(v * 100)) : v; };
      function paint() {
        var a = parseFloat(lo.value), b = parseFloat(hi.value);
        if (a > b) { if (document.activeElement === lo) { hi.value = a; b = a; } else { lo.value = b; a = b; } }
        if (fill) { fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
        if (loOut) loOut.textContent = money(a);
        if (hiOut) hiOut.textContent = money(b);
      }
      function commit() {
        if (loIn) loIn.value = parseFloat(lo.value) > 0 ? lo.value : '';
        if (hiIn) hiIn.value = parseFloat(hi.value) < max ? hi.value : '';
        var form = wrap.closest('form[data-hf-coll-form]');
        if (form) schedule(form);
      }
      [lo, hi].forEach(function (r) { r.addEventListener('input', paint); r.addEventListener('change', commit); });
      paint();
    });
  }

  function schedule(form) {
    clearTimeout(timer);
    timer = setTimeout(function () { go(formUrl(form), { push: true, reveal: !mqPanel.matches }); }, 200);
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form[data-hf-coll-form]');
    if (!form || e.target.matches('[data-hf-range]')) return;
    schedule(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-hf-coll-form]');
    if (!form) return;
    e.preventDefault();
    clearTimeout(timer);
    go(formUrl(form), { push: true, reveal: !mqPanel.matches });
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (a) {
      var sec = root();
      if (!sec || !sec.contains(a) || a.target) return;
      if (a.hasAttribute('data-hf-coll-more')) { e.preventDefault(); more(a); return; }
      if (a.hasAttribute('data-hf-coll-link') || a.closest('.hf-pagination')) {
        e.preventDefault();
        clearTimeout(timer);
        go(a.href, { push: true, reveal: true });
      }
      return;
    }
    /* "Show N products" closes the phone panel (hf-theme.js); then show the results from the top if we were deep in the grid */
    if (e.target.closest('.hf-filters__foot [data-hf-filters-close]')) requestAnimationFrame(revealResults);
  });

  window.addEventListener('popstate', function () {
    if (!root()) return;
    var url = location.pathname + location.search;
    if (url === shownUrl) return; // hash change only
    go(url, { push: false });
  });

  function init(scope) {
    initRanges(scope || document);
    var sec = root();
    if (sec) keepChipInView(sec);
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
